import { EventEmitter, Injectable, Output } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { AuthorityEnum, EmployeeUser } from 'src/app/models/employee-user.model';
import { Applicant } from '../../models/applicant.model';
import { HttpCERS } from '../cers.api';
import { VideotecaService } from '../videoteca/videoteca.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  @Output() loginSuccess = new EventEmitter();
  @Output() loginFail = new EventEmitter();

  private readonly APPLICANT_TOKEN = 'applicant_token';
  private readonly APPLICANT = 'applicant';
  private readonly APPLICANT_ID = 'applicant_id';
  private readonly TEMPLATE_ID = 'template_id';

  private readonly EMPLOYEE_TOKEN = 'employee_token';
  private readonly EMPLOYEE = 'employee';
  private readonly EMPLOYEE_ID = 'employee_id';
  private readonly EMPLOYEE_ROLE = 'employee_role';
  private readonly APPLICANT_TEMPLATE = 'applicant_template';


  constructor(private api: HttpCERS, private storage: LocalStorageService) {
    this.api = api.setContext('/auth');
    this.api.setLocalContext('', 'http://localhost:8000');
  }

  // Applicant
  applicantSignin(user) {
    this.api.post('/gabarito', user)
    .subscribe(
      response => {
        const applicantLogged: Applicant = response.applicant;
        this.storage.set(this.APPLICANT_TOKEN, response.token);
        this.storage.set(this.APPLICANT, applicantLogged);
        this.storage.set(this.APPLICANT_ID, applicantLogged.id);
        this.loginSuccess.emit();
      },
      error => {
        this.loginFail.emit(error);
      }
    );
  }

  applicantLogout() {
    this.storage.remove(this.APPLICANT_TOKEN);
    this.storage.remove(this.APPLICANT);
    this.storage.remove(this.APPLICANT_ID);
    this.storage.remove(this.TEMPLATE_ID);
  }

  getLoggedApplicant(): Applicant {
    return this.storage.get(this.APPLICANT);
  }

  getLoggedApplicantId(): number {
    return this.storage.get(this.APPLICANT_ID);
  }

  getLoggedApplicantToken() {
    return this.storage.get(this.APPLICANT_TOKEN);
  }

  isApplicantLoggedIn() {
    let isLoggedIn = false;
    if (this.getLoggedApplicantId()) {
      isLoggedIn = true;
    }
    return isLoggedIn;
  }


  // Employee
  employeeSignin(user) {
    this.api.post('/gabarito/employee', user)
    .subscribe(
      response => {
        const employeeLogged: EmployeeUser = response.userDetails;
        this.storage.set(this.EMPLOYEE_TOKEN, response.token);
        this.storage.set(this.EMPLOYEE, employeeLogged);
        this.storage.set(this.EMPLOYEE_ID, employeeLogged.id);
        this.storage.set(this.EMPLOYEE_ROLE, employeeLogged.authorities[0].authority);

        this.loginSuccess.emit();
      },
      error => {
        this.loginFail.emit(error);
      }
    );
  }

  employeeLogout() {
    this.storage.remove(this.EMPLOYEE_TOKEN);
    this.storage.remove(this.EMPLOYEE);
    this.storage.remove(this.EMPLOYEE_ID);
    this.storage.remove(this.EMPLOYEE_ROLE);
  }

  getLoggedEmployee(): EmployeeUser {
    return this.storage.get(this.EMPLOYEE);
  }

  getLoggedEmployeeId(): number {
    return this.storage.get(this.EMPLOYEE_ID);
  }

  getLoggedEmployeeToken() {
    return this.storage.get(this.EMPLOYEE_TOKEN);
  }

  isEmployeeLoggedIn() {
    let isLoggedIn = false;
    if (this.getLoggedEmployeeId()) {
      isLoggedIn = true;
    }
    return isLoggedIn;
  }

  isEmployeeAdmin() {
    const role = this.storage.get(this.EMPLOYEE_ROLE);
    return role && role === AuthorityEnum.ADMIN.toString();
  }

  setApplicantTemplateStatus(id, data) {
    let list: any[] = this.storage.get(this.APPLICANT_TEMPLATE);
    if (!list) {
      list = [];
    }

    const item = { id, data };

    list = list.filter(filterItem => filterItem.id !== id);

    list.push(item);

    this.storage.set(this.APPLICANT_TEMPLATE, list);
  }

  getApplicantTemplateStatus(id) {
    const list: any[] = this.storage.get(this.APPLICANT_TEMPLATE);

    let data;
    if (list) {
      const find = list.find(item => item.id === id);

      if (find) {
        data = find.data;
      }
    }

    return data;
  }

  setTemplateApplicantId(templateId: number) {
    this.storage.set(this.TEMPLATE_ID, templateId);
  }

  getTemplateApplicantId() {
    return this.storage.get(this.TEMPLATE_ID);
  }
}
